"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83741],{

/***/ 983741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Layout": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var tenants_template_desktop_module_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(254607);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var components_desktop_organisms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(211888);
/* harmony import */ var _template_desktop_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(794416);
/* harmony import */ var helpers_translate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(858045);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const Layout = (_param)=>{
    var { children  } = _param, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    const { partner , footerDataConfig ={} , vietinFooterDataConfig ={} , rightMenuTopBarButtonConfigs =[] ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const isVietin = partner === "vietin";
    const rightMenu = (0,_template_desktop_helpers__WEBPACK_IMPORTED_MODULE_3__/* .renderTopBarMenu */ .O)((0,helpers_translate__WEBPACK_IMPORTED_MODULE_4__/* .translateObject */ .bb)(rightMenuTopBarButtonConfigs), [
        ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_desktop_organisms__WEBPACK_IMPORTED_MODULE_5__/* .LanguageSelector */ .$, {})
    ]);
    const footerData = isVietin ? (0,helpers_translate__WEBPACK_IMPORTED_MODULE_4__/* .translateObject */ .bb)(vietinFooterDataConfig) : (0,helpers_translate__WEBPACK_IMPORTED_MODULE_4__/* .translateObject */ .bb)(footerDataConfig);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(tenants_template_desktop_module_Layout__WEBPACK_IMPORTED_MODULE_6__.Layout, _objectSpreadProps(_objectSpread({}, props), {
        rightMenu: rightMenu,
        footerData: footerData,
        children: children
    }));
};


/***/ })

}]);